/** Personal OOF retains instant scheduling and the account-aware date picker. */
import { useI18n } from '@platform/i18n';
import { breadcrumbFor, localizeRegistry, MailboxAutomaticRepliesBody, PageBody, PageHeader, type MailboxAutomaticRepliesAdapter } from '@platform/ui';
import { useLocation } from 'react-router';
import { api, type AutomaticReplies } from '../api';
import { publishAutomaticReplies } from '../automatic-replies-store';
import { AccountDateTimePicker } from '../date-time-picker';
import { webmailNavigation } from '../navigation';
import { SettingsTabs } from './settings-tabs';

const adapter: MailboxAutomaticRepliesAdapter<AutomaticReplies> = { load: () => api.myAutomaticReplies(), save: (input) => api.setAutomaticReplies(input) };
export function AutomaticRepliesPage() {
  const { t } = useI18n();
  const { pathname } = useLocation();
  return <div className="min-h-0 flex-1 overflow-y-auto">
    <PageHeader breadcrumb={breadcrumbFor(localizeRegistry(webmailNavigation, t), pathname)} title={t('webmail.automaticReplies.title')} description={t('webmail.automaticReplies.description')} tabs={<SettingsTabs active="automatic-replies" />} />
    <PageBody width="form"><MailboxAutomaticRepliesBody adapter={adapter} capabilities={{ write: true, schedule: 'editable' }} dateTimePicker={AccountDateTimePicker} onSaved={publishAutomaticReplies} /></PageBody>
  </div>;
}
